import React from "react";
import { Link } from "react-router-dom";
import { formatDateWithOrdinal } from "../../../../../global_functions/global";
import { ReactComponent as Verify } from "../../../../../../src/assets/icons/verify.svg";
import { Input } from "../../../../common";
import { HTMLTagsUsingDOMParser } from "../../../../../utils/Helper";

export const RegistrationDetails = ({ company }) => {
  return (
    (company?.registration_body || company?.legal_form || company?.date_of_issue || company?.activities || company?.capital || company?.date_of_expiry || company?.license_no || company?.trade_license) && <div className="bg-white rounded-xl p-6 mb-6">
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <h3 className="text-start text-primary text-[18px] sm:text-f18 font-semibold">
            Registration Details
          </h3>
          <div style={{ width: "20px", height: "20px", }}>
            {company?.claimed && <Verify />}
          </div>
        </div>

        <div className="flex flex-row justify-between">
          <div style={{ width: "70%" }} className="text-start gap-4 flex flex-col">
            {company?.registration_body && (
              <div>
                <span className="text-[12px] sm:text-f12 text-secondary">Registration Body</span>
                <p className="text-[14px] sm:text-f16  text-secondarytwoer">
                  {company?.registration_body || ""}
                </p>
              </div>
            )}
            {company?.legal_form && (
              <div>
                <span className="text-[12px] sm:text-f12 text-secondary">Legal Form</span>
                <p className="text-[14px] sm:text-f16  text-secondarytwoer">
                  {company?.legal_form || ""}
                </p>
              </div>
            )}
            {company?.date_of_issue && (
              <div>
                <span className="text-[12px] sm:text-f12 text-secondary">Date of Issue</span>
                <p className="text-[14px] sm:text-f16  text-secondarytwoer">
                  {formatDateWithOrdinal(company?.date_of_issue)}
                </p>
              </div>
            )}
            {company?.activities && (
              <div>
                <span className="text-[12px] sm:text-f12 text-secondary">Activities</span>
                <p className="text-[14px] sm:text-f16  text-secondarytwoer">
                  {`${HTMLTagsUsingDOMParser(company?.activities)}`}
                </p>
              </div>
            )}
          </div>
          <div className="flex gap-10 sm:flex-row flex-col">
            <div className="text-start gap-4 flex flex-col">
              {company?.capital && (
                <div>
                  <span className="text-[12px] sm:text-f12 text-secondary">Capital</span>
                  <p className="text-f16 text-secondarytwo">
                    {company?.capital}
                  </p>
                </div>
              )}
              {company?.date_of_expiry && (
                <div>
                  <span className="text-[12px] sm:text-f12 text-secondary">Date of Expiry</span>
                  <p className="text-[14px] sm:text-f16  text-secondarytwoer">
                    {formatDateWithOrdinal(company?.date_of_expiry)}
                  </p>
                </div>
              )}
              {company?.license_no && (
                <div>
                  <span className="text-[12px] sm:text-f12 text-secondary">Trade License</span>
                  <p className="text-[14px] sm:text-f16  text-secondarytwoer">
                    {company?.license_no}
                  </p>
                </div>
              )}
              {company?.trade_license && (
                <Link
                  to={company?.trade_license}
                  target="_blank"
                  className="font-semibold text-f14 text-link"
                >
                  View License
                </Link>
              )}
            </div>
            <div className="flex items-end">
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  );
};
